import type { PacketDetailNextButtonClickEvent } from 'components/DeviceView/DeviceViewContent/PacketDetail/PacketDetail';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { animateNode } from './animateNode';
import { getPathInspectorTabToResetData } from './helpers/getPathInspectorTabToResetData';
import { resetPathInspectorTab } from './resetPathInspectorTab';

export const pathLookupDetailNextButtonClick: GraphCommandFactory<
  PacketDetailNextButtonClickEvent
> = (cmdContext, dispatch) => (command) => {
  const { currentEdge, currentDeviceViewEntity, followingNode } =
    getPathInspectorTabToResetData(
      command.edgeId,
      'target',
      cmdContext.getState().graph,
      cmdContext.getDeviceView(),
    );

  dispatch(resetPathInspectorTab, {
    currentDeviceViewEntity,
    edgeId: command.edgeId,
    edgesToUnhighlight: [
      command.edgeId,
      ...(currentEdge?.nextEdgeIds !== undefined
        ? currentEdge.nextEdgeIds
        : []),
    ],
    followingNode,
    nodeSn: command.nodeSn,
    selectedIncomingEdgeId: command.edgeId,
  });

  dispatch(animateNode, {
    currentNodeSn: command.nodeSn,
    followingNodeSn: followingNode?.sn,
  });
};
